// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3Y-B2","filesListContainer":"PosDisputesFiles_filesListContainer__13-Yw","filesButton":"PosDisputesFiles_filesButton__2V22D"};